<template>
  <div class="nav-bar">
    <strong @click="handleLocation">
      {{ locationName }} <i class="fa-solid fa-angle-down"></i>
    </strong>
    <el-dropdown trigger="click">
      <strong class="user-name-merchant">
        <img :src="defaultUserImg">
        {{ userName }} <i class="fa-solid fa-angle-down"></i>
      </strong>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <div class="text-danger" @click="logout">
            Đăng xuất
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <LayoutPopup id="chon-chi-nhanh">
			<template #title>Chọn chi nhánh</template>
			<template #content>
				<div
					class="content-block"
					v-for="location in listLocation"
					:key="location.coLocationId"
					@click="setLocation(location)"
				>
					<div class="location-name">{{location.name}}</div>
          <div>
            <i class="fa-solid fa-arrow-right-long text-primary"></i>
          </div>
				</div>
			</template>
			<template #control-right>
				<BaseButton
					@click="hidePopup('selectLocation')"
          size="sm"
					variant="outline"
          :disabled="allowExit"
				>
          Thoát
        </BaseButton>
			</template>
		</LayoutPopup>
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocationName, getUserName, getStorageItem} from '../../utils/auth'
import defaultUserImg from '@/assets/images/user-default.png'
import getListLocation from "@/mixins/location/getListLocationDashboard"
import { AuthService } from '../../services/auth.service'
import { PackageService } from "@/services/nextshop/package.service"
import { removeStorageItem } from '@/utils/auth'

import {
  RoleService
} from '@/services/nextshop/role.service'
import VueCookies from 'vue-cookies'
export default {
  data() {
    return {
      defaultUserImg: defaultUserImg,
      visible: false,
      listLocation: [],
      checkChangePlan: false,
      loading: false,
    }
  },
  mixins: [getListLocation],
  computed: {
    locationName() {
      return getLocationName()
    },
    userName() {
      return getUserName()
    },
    allowExit() {
      return Boolean(!this.locationName)
    }
  },
  async created() {
    this.loading = true
    if(getStorageItem("locationName")) this.loading = false
    this.listLocation = await this.getListLocation()
    this.loading = false
    if(this.listLocation.length == 0){
			let inforUsers = JSON.parse(localStorage.getItem("auth.currentUser"))
			await this.merchantPlanConfigs()
			if(this.checkChangePlan){
				if(inforUsers.role == 'employee'){
					this.$router.push('/forbidden')
				}else{
					this.$router.push('/package-select-v2')
				}
			}else{
        this.$router.push('/dashboard')
      }
		}else{
      this.checkLocation()
    }
    
  },
  methods: {
    logout() {
      AuthService.makeLogout()
      localStorage.removeItem('locationName')
    },
    checkLocation() {
      if (!getStorageItem("locationName")) {
        if(this.listLocation.length == 1) {
          this.setLocation(this.listLocation[0])
          return
        }
        this.showPopup('chon-chi-nhanh')
      }else{
        this.locationNameSelected = getLocationName()
      }
    },
    handleLocation() {
      if (this.listLocation) {
        this.showPopup('chon-chi-nhanh')
      }
    },
    async setLocation(data) {
      this.locationNameSelected = data.name
      this.$store.commit("auth/SET_CURRENT_LOCATION", data.coLocationId);
      VueCookies.set("LID", data.coLocationId)
      VueCookies.set("IID", (data.inventories  && data.inventories.length > 0) ? data.inventories[0].coInventoryId : '')
      localStorage.setItem("locationName", JSON.stringify(data))
      localStorage.setItem("inventoryID", (data.inventories && data.inventories.length > 0) ? data.inventories[0].coInventoryId : '');
      await RoleService.getListPermissionsUser()
      this.hidePopup('chon-chi-nhanh')
      //set permission
      await RoleService.getListPermissionsUser()
      location.reload()
    },
    async merchantPlanConfigs() {
			try {
				const response = await PackageService.merchantPlanConfigs()
				if (response.success) {
          if(response.data.plan == null || response.data.plan == ''){
            removeStorageItem('locationName')
						AuthService.packageBackHome()
          }else{
            this.checkChangePlan = response.data.planChanged
          }
				}
			} catch (error) {
				console.log(error);
			}
		},
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  position: relative;
  background-color: #fff;
  height: 63px;
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  strong {
    font-weight: bold !important;
    cursor: pointer;
  }
  .content-block {
    cursor: pointer;
    margin-bottom: 10px;
    border-radius: 4px;
    border: 1.5px solid #ddd;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    .location-name {
      font-weight: bold;
      font-size: 14px;
    }
    i {
      font-size: 18px;
    }
  }
  i{
    padding: 0 5px;
  }
  .user-name-merchant {
    padding-left: 20px;
    img {
      height: 100%;
      width: 40px;
      border-radius: 50%;
      margin-right: 4px;
    }
  }
}
</style>